import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PwaService, UserLoginComponent } from '@definitiv-packages/angular-dba-library';

import { AppService, ObjektViewService, SafetyPointFormModelView, SafetyPointFormModelViewService, SafetyPointViewService, TodoViewService } from '../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  public ready: boolean = false;
  public showLogin: boolean = false;
  
  public unreadCount: number = 0;
  public todosCount: number = 0;  

  constructor(
    public appService: AppService,
    private dialog: MatDialog,
    private todoService: TodoViewService,
    private objektViewService: ObjektViewService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
 

    //private safetyPointFormModelView: SafetyPointFormModelView,
    pwaService: PwaService,
  ) {
    pwaService.Init();
  }

  public async ngOnInit() {
  
    try {
      
      await this.appService.init();
      await this.appService.loginFromLocalStorage();
      await this.getCountTodos();
      this.todoService.todoCount$.subscribe(x => {
        this.todosCount = x;
      });        

    }
    finally {
      this.ready = true;
    }
  }
  private async getCountTodos() {


      try { 
            var resultList = await Promise.all([
        this.todoService.getList(),
        this.safetyPointFormModelViewService.getList(),
        this.objektViewService.getList()
      ]) 
 
      var count = 0;
      resultList[0].forEach(elem=>{
        count += resultList[2].find(x=>x.ObjektID == elem.ObjektId)?.SafetyPointCount!;
      })
            
      var cntsafety = resultList[1].filter(x=>(resultList[0].map(y=>y.ObjektId).includes(x.ObjektID))).length;
      this.todoService.setCount(count-cntsafety)     
    }
    catch(error) {
      console.error(error)
    }
  }
  public login(): void {
    this.dialog.open(UserLoginComponent).afterClosed().subscribe();
  }
}
